export default __webpack_public_path__ + "static/media/PP.bb64f168.png";